import { render, staticRenderFns } from "./AlertSignature.vue?vue&type=template&id=dde09ec2"
import script from "./AlertSignature.vue?vue&type=script&lang=js"
export * from "./AlertSignature.vue?vue&type=script&lang=js"
import style0 from "./AlertSignature.vue?vue&type=style&index=0&id=dde09ec2&prod&scopped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports